// extracted by mini-css-extract-plugin
export var fullWidthButton = "_ep-0";